import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { ExtraProps } from 'react-markdown'

type HeaderProps = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> &
  ExtraProps

export function h1({ children, ...props }: HeaderProps) {
  const childrenStr =
    typeof children === 'string' ? children : Array.isArray(children) ? children.join('') : ''

  const id = childrenStr.toLowerCase().replace(/\s+/g, '-')

  return (
    <h1 className='text-md font-bold my-4 pb-2 border-b-1 border-border' {...props}>
      <a id={id}>{children}</a>
    </h1>
  )
}

export function h2({ children, ...props }: HeaderProps) {
  return (
    <h2 className='text-md font-semibold my-3' {...props}>
      {children}
    </h2>
  )
}

export function h3({ children, ...props }: HeaderProps) {
  return (
    <h3 className='text-md font-semibold my-2' {...props}>
      {children}
    </h3>
  )
}

export function h4({ children, ...props }: HeaderProps) {
  return (
    <h4 className='font-semibold my-2' {...props}>
      {children}
    </h4>
  )
}

export function h5({ children, ...props }: HeaderProps) {
  return (
    <h5 className='text-xs font-semibold my-1' {...props}>
      {children}
    </h5>
  )
}

export function h6({ children, ...props }: HeaderProps) {
  return (
    <h6 className='text-xs font-semibold my-1' {...props}>
      {children}
    </h6>
  )
}
